// internal icons
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowUp,
  faAngleRight,
  faAngleLeft,
  faAngleUp,
  faAngleDown,
  faSpinner,
  faPlus,
  faXmark,
  faMagnifyingGlassMinus,
  faBan,
  faCircleCheck,
  faEllipsisVertical,
  faCircleInfo,
  faArrowRotateLeft,
  faArrowRotateRight,
  faScissors,
  faRepeat,
  faArrowLeft,
  faArrowRight,
  faDownload,
  faSearch,
  faTrashArrowUp,
  faFloppyDisk,
  faCircleExclamation,
  faLink,
  faSquareCheck,
  faQuestion,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon as Icons } from "@fortawesome/vue-fontawesome";

library.add(
  faArrowUp,
  faAngleRight,
  faAngleLeft,
  faAngleUp,
  faAngleDown,
  faSpinner,
  faXmark,
  faMagnifyingGlassMinus,
  faBan,
  faCircleCheck,
  faSpinner,
  faPlus,
  faEllipsisVertical,
  faCircleInfo,
  faArrowRotateLeft,
  faArrowRotateRight,
  faScissors,
  faRepeat,
  faArrowLeft,
  faArrowRight,
  faDownload,
  faSearch,
  faTrashArrowUp,
  faFloppyDisk,
  faCircleExclamation,
  faLink,
  faSquareCheck,
  faQuestion
);

export default Icons;
